// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3kr2I","overflowing":"ReadFullNote_overflowing__3KtHA"};